import Skeleton from '@carvana/ds-skeleton';
import createComponent from '@carvana/merch-components/createComponent';

type OwnProps = {
  onClick: () => void;
  text: string;
  isLoading: boolean;
};

export const Button = createComponent('button', () => ({
  className:
    'min-h-36 max-w-fit overflow-hidden whitespace-normal break-words rounded-full bg-blue-100 px-xl py-md text-left text-text-strong-active t-label-sm hover:text-text-strong active:bg-blue-100 active:text-text-strong'
}));

export default function QuestionButton({ onClick, text, isLoading }: OwnProps) {
  const estimateButtonWidth = () => {
    const padding = 32; // padding px-xl (16px each side)
    const charWidth = 7; // Approximate character width for t-label-sm font and to account for letter spacing

    return (text.length * charWidth + padding).toString() + 'px';
  };

  if (isLoading) {
    return (
      <Skeleton
        className="rounded-full"
        height="36px"
        width={estimateButtonWidth()}
      />
    );
  }

  return (
    <Button
      onClick={onClick}
      data-testid="prompt-button"
      data-analytics-id="Shaqbot Section"
      data-analytics-attributes={JSON.stringify({
        text: text
      })}
    >
      {text}
    </Button>
  );
}
